import { render, staticRenderFns } from "./MenuControlloAlloggi.vue?vue&type=template&id=788a8b04&"
import script from "./MenuControlloAlloggi.vue?vue&type=script&lang=ts&"
export * from "./MenuControlloAlloggi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports